import React from 'react';
import { motion } from 'framer-motion';
import { MegaphoneIcon, ShoppingCartIcon, PartyPopperIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { renderRich } from '../utils/richText';

/** Each point gets its own badge treatment so the row never feels repetitive. */
const BADGES = [{
  icon: MegaphoneIcon,
  shape: 'rounded-full bg-blue-600 text-white shadow-lg shadow-blue-600/30',
  halo: 'bg-blue-500/15'
}, {
  icon: ShoppingCartIcon,
  shape: 'rounded-full border-[3px] border-blue-600 bg-white text-blue-600 shadow-md shadow-blue-600/10',
  halo: 'bg-blue-400/15'
}, {
  icon: PartyPopperIcon,
  shape: 'rounded-full bg-slate-900 text-blue-300 shadow-lg shadow-slate-900/25',
  halo: 'bg-slate-900/10'
}];
export function BrokenSection() {
  const {
    t
  } = useLanguage();
  return <section id="why-us" className="w-full border-t border-slate-200 bg-slate-50" data-id="element-28" data-mp="1ib921b6fbqc">
      <div className="mx-auto w-full max-w-[1280px] px-5 py-20 sm:px-8 lg:py-28" data-id="element-29" data-mp="1g87ql4kpw6b">
        <div className="mx-auto max-w-[820px] text-center" data-id="element-30" data-mp="2wopc2sfzi892">
          <h2 className="text-[clamp(1.9rem,4vw,3rem)] font-extrabold leading-tight tracking-[-0.03em] text-slate-900" data-id="element-31" data-mp="31pddm81ua7hj">
            {t.broken.title}
          </h2>
          <p className="mt-6 text-[18px] leading-relaxed text-slate-600" data-id="element-32" data-mp="2mu73p9zmhoix">
            {t.broken.body}
          </p>

          <div className="mx-auto mt-8 max-w-[720px] rounded-2xl border border-blue-100 bg-blue-50/70 px-6 py-5" data-id="element-33" data-mp="3fgrzqnr1most">
            <p className="text-[17px] font-bold text-slate-900" data-id="element-34" data-mp="3kfuqr4a6uuhs">
              {renderRich(t.broken.highlightTitle)}
            </p>
            <p className="mt-2 text-[16px] leading-relaxed text-slate-600" data-id="element-35" data-mp="35q5loxyz66c8">
              {t.broken.highlightBody}
            </p>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-1 gap-14 sm:gap-8 md:mt-16 md:grid-cols-3 md:gap-6" data-id="element-36" data-mp="29geravhcum1">
          {t.broken.points.map((point, i) => {
          const badge = BADGES[i];
          const Icon = badge.icon;
          return <motion.article key={point.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.45,
            ease: 'easeOut',
            delay: i * 0.08
          }} className="relative rounded-2xl border border-slate-200 bg-white px-7 pb-7 pt-16 text-center shadow-sm md:pt-14" data-id="element-37" data-mp="gvvy0guhoezx" data-mpi={i}>
                <span className="absolute -top-10 left-1/2 -translate-x-1/2 md:-top-9" aria-hidden="true" data-id="element-38" data-mp="3pbyudqg5ih8y">
                  <span className={`absolute inset-0 rounded-full blur-lg ${badge.halo}`} data-id="element-39" data-mp="3kbb63cjb4eif" />
                  <span className={`relative inline-flex h-[84px] w-[84px] items-center justify-center ring-8 ring-slate-50 md:h-[72px] md:w-[72px] ${badge.shape}`} data-id="element-40" data-mp="3bcfx5sovoqbf">
                    <Icon size={36} strokeWidth={1.9} data-id="element-41" data-mp="1lw3kel8bzik0" />
                  </span>
                </span>
                <h3 className="text-[19px] font-bold leading-snug tracking-tight text-slate-900" data-id="element-42" data-mp="1qu5e003dv09q">
                  {point.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-43" data-mp="1vujaqlzjansg">
                  {point.text}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}